import OriginSearch from './search';
import Option from './option';
export * from './interface';
var Search = OriginSearch;
Search.Option = Option;
export default Search;